'use client'

import * as React from 'react'

interface ViewerState {
  assetid: string
  cid?: string | null
  postslug?: string | null
}

interface Ctx {
  push: (s: ViewerState) => void
  pop: () => ViewerState | undefined
  peek: () => ViewerState | undefined
  size: number
  clear: () => void
}

const PhotoStackContext = React.createContext<Ctx | null>(null)

export function PhotoStackProvider({ children }: { children: React.ReactNode }) {
  const stackRef = React.useRef<ViewerState[]>([])

  const ctx = React.useMemo<Ctx>(
    () => ({
      push: s => {
        stackRef.current.push(s)
      },
      pop: () => stackRef.current.pop(),
      peek: () => stackRef.current.at(-1),
      get size() {
        return stackRef.current.length
      },
      clear: () => {
        stackRef.current = []
      },
    }),
    [],
  )

  return <PhotoStackContext.Provider value={ctx}>{children}</PhotoStackContext.Provider>
}

export function usePhotoStack() {
  const ctx = React.useContext(PhotoStackContext)
  if (!ctx) {
    throw new Error('usePhotoStack must be used within PhotoStackProvider')
  }
  return ctx
}
